import ApplicationTokenConfiguration from './ApplicationTokenConfiguration';

export default ApplicationTokenConfiguration;
